import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=420a87bd"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports